import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import {CONFIG_ENV} from '@/config';


@Component({components:{}})
export default class Cadouri extends Vue {
    @Prop() listid!: number;
    @Prop() list_name_as_link!:string;
    myBoolTrue:boolean=true;
    myBoolFalse:boolean=false;
    ajaxIsRunning:boolean=false;

    $refs:any;
    constructor(){
        super();
    }



}
